import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import ReactDOMServer from 'react-dom/server'
import html2pdf from 'html2pdf.js'
import DespachoView from './DespachoView'
import brasao from '../../assets/brasilNav.png'

const NovoDespacho = () => {
    const mediaWeb = window.matchMedia("(min-width:600px)").matches
    const idProcesso = window.location.pathname.slice(23)

    const [processo, setProcesso] = useState({})
    const [users, setUsers] = useState([])
    const [dadosForm, setDadosForm] = useState({
        destino: "",
        destinoPrazo: "",
        prazo: "",
        texto: ""
    })

    const [despachoCriado, setDespachoCriado] = useState(null)
    const pdfRef = useRef()

    useEffect(() => {
        axios.post('/api/juridico/getProcesso', { id: idProcesso })
            .then(res => setProcesso(res.data))
            .catch(error => alert(error.response?.data?.message || error.message))

        axios.get('/api/juridico/getUsers')
            .then(res => setUsers(res.data))
            .catch(error => alert(error.response?.data?.message || error.message))
    }, [idProcesso])

    const updateField = (e) => {
        const { name, value } = e.target
        setDadosForm(prev => ({ ...prev, [name]: value }))
    }

    const enviar = () => {
        axios.post('/api/juridico/despacho', {
            idUserDestino: dadosForm.destino,
            destino: dadosForm.destino,
            destinoPrazo: dadosForm.destino === "Aguardando Prazo" ? dadosForm.destinoPrazo : null,
            prazo: dadosForm.destino === "Aguardando Prazo" ? dadosForm.prazo : null,
            idProcesso: processo._id,
            texto: dadosForm.texto
        })
            .then(res => {
                const { message, despachoCriado } = res.data
                setDespachoCriado(despachoCriado)
                gerarPDF(despachoCriado, processo, message)
            })
            .catch(error => alert(error.response?.data?.message || error.message))
    }

    const gerarPDF = async (despacho, processo, message) => {
        try {
            const elementHTML = ReactDOMServer.renderToString(
                <DespachoView despacho={despacho} processo={processo} />
            )

            const tempElement = document.createElement('div')
            tempElement.innerHTML = elementHTML
            document.body.appendChild(tempElement)

            const options = {
                margin: [10, 10, 10, 10],
                filename: `despacho_${despacho._id}.pdf`,
                image: { type: 'jpeg', quality: 0.8 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'a4',
                    orientation: 'portrait',
                },
            }

            const pdfBlob = await new Promise((resolve, reject) => {
                html2pdf()
                    .set(options)
                    .from(tempElement)
                    .toPdf()
                    .outputPdf('blob')
                    .then(resolve)
                    .catch(reject)
            })

            document.body.removeChild(tempElement)

            const formData = new FormData()
            formData.append('file', pdfBlob, `despacho_${despacho._id}.pdf`)
            formData.append('idProcesso', processo._id)
            formData.append('user', localStorage.nomeJ || '')
            formData.append('nomeArquivo', `Despacho`)
            formData.append('tipoAnexo', 'Despacho')
            formData.append('dataCriacao', new Date().toLocaleString())

            await axios.post('/api/anexos/postsJuridico', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })

            alert(message)
            window.location = `/juridico/processo/${processo._id}`
        } catch (error) {
            console.error('Erro ao gerar ou enviar o PDF:', error)
            alert('Erro ao gerar ou enviar o PDF. Contate o suporte.')
        }
    }

    return (
        <>
            <div className="capaPedCaixaBranca" style={{ marginBottom: "2vh" }}>
                <img src={brasao} alt="Brasil" className='brasaoPed' />
                <div className='conselho'>
                    CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL DA 1ª REGIÃO
                </div>

                <div className="capaPedCaixaVerdeNumero">
                    {processo.numero && processo.dataCriacao ? (
                        <>PROCESSO Nº {processo.numero}/{processo.dataCriacao.slice(0, 4)}</>
                    ) : null}
                </div>

                <div className="capaPedCaixaVerdeInfracoes">
                    <span className="spanRelatorRevisor" style={{ margin: "1vw 0 0 1vw", float: mediaWeb ? null : "left" }}>
                        Destino
                    </span>
                    <select
                        name="destino"
                        className="input"
                        style={{ marginLeft: "1vw", float: "left" }}
                        onChange={updateField}
                        value={dadosForm.destino}
                    >
                        <option value=""></option>
                        <optgroup label="Pessoas">
                            {users.map(u => (
                                <option key={`opcao-${u._id}`} value={u._id}>
                                    {u.nome}
                                </option>
                            ))}
                        </optgroup>
                        <optgroup label="Situações">
                            <option value="Arquivo">Arquivo</option>
                            <option value="Presidência">Presidência</option>
                            <option value="Ações Ajuizadas">Ações Ajuizadas</option>
                            <option value="Procedimentos no MP">Procedimentos no MP</option>
                            <option value="Aguardando Prazo">Aguardando Prazo</option>
                        </optgroup>
                    </select>
                </div>

                {dadosForm.destino === "Aguardando Prazo" && (
                    <>
                        <div className="capaPedCaixaVerdeInfracoes" style={{ marginTop: "2vh" }}>
                            <span className="spanRelatorRevisor" style={{ margin: "1vw 0 0 1vw", float: mediaWeb ? null : "left" }}>
                                Destino após prazo
                            </span>
                            <select
                                name="destinoPrazo"
                                className="input"
                                style={{ marginLeft: "1vw", float: "left" }}
                                onChange={updateField}
                                value={dadosForm.destinoPrazo}
                            >
                                <option value=""></option>
                                <optgroup label="Pessoas">
                                    {users.map(u => (
                                        <option key={`opcao-${u._id}`} value={u._id}>
                                            {u.nome}
                                        </option>
                                    ))}
                                </optgroup>
                                <optgroup label="Situações">
                                    <option value="Arquivo">Arquivo</option>
                                    <option value="Presidência">Presidência</option>
                                    <option value="Ações Ajuizadas">Ações Ajuizadas</option>
                                    <option value="Procedimentos no MP">Procedimentos no MP</option>
                                </optgroup>
                            </select>
                        </div>
                        <div className="capaPedCaixaVerdeInfracoes" style={{ marginTop: "2vh" }}>
                            <span className="spanRelatorRevisor" style={{ margin: "1vw 0 0 1vw", float: mediaWeb ? null : "left" }}>
                                Prazo final
                            </span>
                            <input
                                type="date"
                                name="prazo"
                                className="input"
                                style={{ marginLeft: "1vw", float: "left" }}
                                onChange={updateField}
                                value={dadosForm.prazo}
                            />
                        </div>
                    </>
                )}

                <div className="capaPedCaixaVerdeInfracoes" style={{ marginTop: "2vh", height: "30vh" }}>
                    <span className="spanRelatorRevisor" style={{ margin: "1vw 0 0 1vw", float: mediaWeb ? null : "left" }}>
                        Texto
                    </span>
                    <textarea
                        className="input"
                        name="texto"
                        onChange={updateField}
                        value={dadosForm.texto}
                        style={{
                            marginLeft: "1vw",
                            float: "left",
                            width: mediaWeb ? "60vw" : "70vw",
                            height: "20vh"
                        }}
                    />
                </div>

                <button className="botaoNPed" style={{ marginBottom: "2vh" }} onClick={enviar}>
                    ENVIAR
                </button>
            </div>
        </>
    )
}

export default NovoDespacho
